// profileApi.js
import apiClient from './apiClient';

const profileApi = {
    async myProfile() {
        const response = await apiClient('').get('/users/profile/me');
        return response.data;
    },
};

export default profileApi;
